import { useState } from 'react';
import { AddressSection } from './AddressesSection';
import { AddressType, AddressTypeMap } from 'apps/customer/src/types/innerLayout/addresses';

export const Address = () => {
  const [selectedShippingAddressId, setSelectedShippingAddressId] =
    useState<number>();
  const [selectedBillingAddressId, setSelectedBillingAddressId] =
    useState<number>();
  const [isAddingAddress, setIsAddingAddress] = useState({
    SHIPPING: false,
    BILLING: false,
  });

  const handleShippingAddressIdChange = (id: number | undefined) => {
    setSelectedShippingAddressId(id);
    if (id !== undefined) {
      setSelectedBillingAddressId(undefined);
      setIsAddingAddress({SHIPPING: false, BILLING: false});
    }
  };

  const handleBillingAddressIdChange = (id: number | undefined) => {
    setSelectedBillingAddressId(id);
    if (id !== undefined) {
      setSelectedShippingAddressId(undefined);
      setIsAddingAddress({SHIPPING: false, BILLING: false});
    }
  };

  const handleAddingAddress = ({isAdding, addressType}: {isAdding: boolean, addressType?: AddressType}) => {
    if (addressType === AddressTypeMap.SHIPPING) {
      setIsAddingAddress({SHIPPING: isAdding, BILLING: false});
    } else if (addressType === AddressTypeMap.BILLING) {
      setIsAddingAddress({SHIPPING: false, BILLING: isAdding});
    }
    if (isAdding) {
      setSelectedShippingAddressId(undefined);
      setSelectedBillingAddressId(undefined);
    }
  };

  return (
    <section className="flex flex-col pb-12">
      <h2 className="mb-5 text-2xl font-semibold leading-8 text-gray-900 md:english-heading-h5-semibold md:mb-8">
        Address
      </h2>
      <section className="space-y-3">
        <AddressSection
          selectedAddressId={selectedShippingAddressId}
          setSelectedAddressId={handleShippingAddressIdChange}
          currentAddressType={AddressTypeMap.SHIPPING}
          isAddingAddress={isAddingAddress}
          setIsAddingAddress={handleAddingAddress}
        />
        <AddressSection
          selectedAddressId={selectedBillingAddressId}
          setSelectedAddressId={handleBillingAddressIdChange}
          currentAddressType={AddressTypeMap.BILLING}
          isAddingAddress={isAddingAddress}
          setIsAddingAddress={handleAddingAddress}
        />
      </section>
    </section>
  );
};
